import { Box, Button, Container, Typography } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import useList from "./useList";
import Admins from "@/templates/Admins";

export const List = () => {
  const { page, count, list, handleGoToCreate, isLoading } = useList();

  return (
    <Container maxWidth={"xl"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Typography
          component={"h1"}
          variant="h5"
          fontWeight={"bold"}
          gutterBottom
        >
          도장 매니저 목록
        </Typography>
        <Button
          variant={"contained"}
          disableElevation
          startIcon={<AddIcon />}
          onClick={handleGoToCreate}
        >
          매니저 등록
        </Button>
      </Box>
      <Admins.List
        page={page}
        count={count}
        list={list}
        isLoading={isLoading}
      />
    </Container>
  );
};
